import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import axios from "axios";

const WhatsNew = () => {
    const [whatsNewData, setWhatsNewData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [formData, setFormData] = useState({
        title: "",
        desc: "",
        image: null,
        date: "",
    });
    const [editData, setEditData] = useState(null);

    const imageBaseURL = "https://api.biznetusa.com/uploads/whatsnew/";

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get("https://api.biznetusa.com/api/all-whatsnew");
            if (response.data.status === 200) {
                setWhatsNewData(response.data.whatsnew);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleShowModal = (data = null) => {
        if (data) {
            setEditData(data);
            setFormData({
                title: data.title,
                desc: data.desc,
                image: null,
                date: data.date,
            });
        } else {
            setEditData(null);
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setFormData({
            title: "",
            desc: "",
            image: null,
            date: "",
        });
        setShowModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: name === "image" ? files[0] : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let response;
            if (editData) {
                response = await updateWhatsNew(editData.id);
            } else {
                response = await createWhatsNew();
            }

            if (response.data.status === 200) {
                const newEntry = response.data.newEntry;

                setWhatsNewData((prevData) => {
                    if (editData) {
                        return prevData.map((newData) =>
                            newData.id === editData.id ? { ...newData, ...newEntry } : newData
                        );
                    } else {
                        return [...prevData, newEntry];
                    }
                });

                setAlertMessage(editData ? "Entry updated successfully!" : "New entry added successfully!");
                handleCloseModal();
            } else {
                setAlertMessage("Failed to submit entry. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setAlertMessage("An error occurred while submitting the form.");
        }
    };


    const createFormData = () => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("desc", formData.desc);
        if (formData.image) {
            data.append("image[]", formData.image);
        }
        data.append("date", formData.date);
        return data;
    };

    const updateFormData = () => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("desc", formData.desc);
        if (formData.image) {
            data.append("image[]", formData.image);
        }
        data.append("date", formData.date);
        return data;
    };


    const createWhatsNew = async () => {
        const data = createFormData();
        return axios.post("https://api.biznetusa.com/api/store-whatsnew", data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    };

    const updateWhatsNew = async (id) => {
        const data = updateFormData();
        return axios.put(`https://api.biznetusa.com/api/update-whatsnew/${id}`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    };

    const handleDelete = async (newsId) => {
        try {
            const response = await axios.delete(`https://api.biznetusa.com/api/deletewhatsnew/${newsId}`);
            if (response.data.status === 200) {
                fetchData();
                setAlertMessage(response.data.message);
            } else {
                setAlertMessage("Failed to delete entry.");
            }
        } catch (err) {
            console.error("Error deleting news:", err);
            setAlertMessage("An error occurred while deleting the entry.");
        }
    };

    return (
        <div className="container mt-4">
            <h1 className="mb-3">What's New</h1>
            {alertMessage && <Alert variant="danger">{alertMessage}</Alert>}
            <button className="btn btn-primary mb-3" onClick={() => handleShowModal()}>
                Add New
            </button>

            <table className="table table-bordered table-striped text-center align-middle">
                <thead className="table-light">
                    <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Images</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {whatsNewData.map((mapItem) => (
                        <tr key={mapItem.id}>
                            <td>{mapItem.id}</td>
                            <td>{mapItem.title}</td>
                            <td>{mapItem.desc}</td>
                            <td>{mapItem.date}</td>
                            <td>
                                {mapItem.images && mapItem.images.length > 0 ? (
                                    <div>
                                        {mapItem.images.map((image) => (
                                            <img
                                                key={image.id}
                                                src={`${imageBaseURL}${image.image}`}
                                                alt={`WhatsNew-${mapItem.id}`}
                                                className="img-thumbnail me-2"
                                                style={{ width: "80px", height: "80px" }}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    "No Images"
                                )}
                            </td>
                            <td>
                                <button className="btn btn-warning btn-sm me-2" onClick={() => handleShowModal(mapItem)}>
                                    Edit
                                </button>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(mapItem.id)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{editData ? "Edit News" : "Add New News"}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Title Input */}
                                    <div className="mb-3">
                                        <label className="form-label">Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            placeholder="Enter title"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            name="desc"
                                            value={formData.desc}
                                            onChange={handleInputChange}
                                            placeholder="Enter description"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="image"
                                            onChange={handleInputChange}
                                            accept="image/*"
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary">
                                        {editData ? "Update News" : "Add News"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && <div className="modal-backdrop fade show"></div>}
        </div>
    );
};

export default WhatsNew;

